import { render, staticRenderFns } from "./DemographyGenderGrid.vue?vue&type=template&id=1a329b18&"
import script from "./DemographyGenderGrid.vue?vue&type=script&lang=js&"
export * from "./DemographyGenderGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports